<template>
    <div class="saas-page linear-workqueue-page">
        <div class="saas-hero card-saas linear-page-hero">
            <div class="saas-hero__main">
                <p class="saas-hero__crumb">
                    <router-link to="/home">{{ trans('general.home') }}</router-link>
                    <span class="px-1">/</span>
                    <span>{{trans('todo.todo')}}</span>
                </p>
                <span class="linear-eyebrow">{{trans('todo.todo')}}</span>
                <h1 class="saas-hero__title">{{trans('todo.todo')}}</h1>
            </div>
            <div class="linear-command-actions">
                <button type="button" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--outline" @click.prevent="showFilterPanel = !showFilterPanel">
                    <admin-icon name="sliders"></admin-icon> <span>{{trans('general.filter')}}</span>
                </button>
            </div>
        </div>

        <div class="row linear-workqueue-grid">
            <div class="col-12 col-lg-4">
                <div class="card-saas linear-admin-panel linear-admin-panel--sticky">
                    <div class="linear-section-head">
                        <div>
                            <span>{{trans('todo.todo')}}</span>
                            <h4>{{trans('todo.add_new_todo')}}</h4>
                        </div>
                    </div>
                    <todo-form @completed="getTodos"></todo-form>
                </div>
            </div>
            <div class="col-12 col-lg-8">
                <transition name="fade">
                    <div class="card-saas linear-filter-card mb-3" v-if="showFilterPanel">
                        <div class="linear-section-head">
                            <div>
                                <span>{{trans('todo.todo')}}</span>
                                <h4>{{trans('general.filter')}}</h4>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label for="">{{trans('todo.keyword')}}</label>
                                    <input class="form-control" name="keyword" v-model="filterTodoForm.keyword">
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group linear-switch-row">
                                    <switches v-model="filterTodoForm.status" theme="bootstrap" color="success"></switches>
                                    <span>{{trans('todo.show_completed')}}</span>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <date-range-picker :start-date.sync="filterTodoForm.start_date" :end-date.sync="filterTodoForm.end_date" :label="trans('general.date_between')"></date-range-picker>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label for="">{{trans('general.sort_by')}}</label>
                                    <select name="order" class="form-control" v-model="filterTodoForm.sort_by">
                                        <option value="title">{{trans('todo.title')}}</option>
                                        <option value="created_at">{{trans('todo.date')}}</option>
                                        <option value="status">{{trans('todo.status')}}</option>
                                        <option value="description">{{trans('todo.description')}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-12 col-md-6">
                                <div class="form-group">
                                    <label for="">{{trans('general.order')}}</label>
                                    <select name="order" class="form-control" v-model="filterTodoForm.order">
                                        <option value="asc">{{trans('general.ascending')}}</option>
                                        <option value="desc">{{trans('general.descending')}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </transition>

                <div class="admin-list-table-card linear-table-card" v-if="todos.total">
                    <div class="linear-section-head linear-section-head--table">
                        <div>
                            <span>{{trans('todo.todo')}}</span>
                            <h4>{{trans('todo.todo')}}</h4>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <table class="table admin-data-table linear-dense-table mb-0">
                            <thead>
                                <tr>
                                    <sortable-th field="title" :sort-by="filterTodoForm.sort_by" :order="filterTodoForm.order" @sort="sortList">{{trans('todo.title')}}</sortable-th>
                                    <sortable-th field="created_at" :sort-by="filterTodoForm.sort_by" :order="filterTodoForm.order" @sort="sortList">{{trans('todo.date')}}</sortable-th>
                                    <sortable-th field="status" :sort-by="filterTodoForm.sort_by" :order="filterTodoForm.order" @sort="sortList">{{trans('todo.status')}}</sortable-th>
                                    <sortable-th field="description" :sort-by="filterTodoForm.sort_by" :order="filterTodoForm.order" @sort="sortList">{{trans('todo.description')}}</sortable-th>
                                    <th class="admin-table-actions-cell">{{trans('general.actions')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="todo in todos.data" :key="todo.id">
                                    <td>
                                        <span class="linear-table-primary" v-text="todo.title"></span>
                                    </td>
                                    <td>
                                        <span class="linear-table-muted">{{todo.date | moment}}</span>
                                    </td>
                                    <td v-html="getStatus(todo)"></td>
                                    <td>
                                        <span class="linear-table-muted linear-table-description" v-text="todo.description"></span>
                                    </td>
                                    <td class="admin-table-actions-cell">
                                        <table-row-action-dropdown>
                                            <b-dropdown-item-button @click.prevent="toggleStatus(todo)">
                                                <admin-icon :name="todo.status ? 'x-circle' : 'check-circle'"></admin-icon>
                                                {{ trans('todo.'+(todo.status ? 'mark_as_incomplete' : 'mark_as_complete')) }}
                                            </b-dropdown-item-button>
                                            <b-dropdown-item-button @click.prevent="editTodo(todo)">
                                                <admin-icon name="pencil"></admin-icon> {{ trans('todo.edit_todo') }}
                                            </b-dropdown-item-button>
                                            <b-dropdown-item-button
                                                v-confirm="{ok: confirmDelete(todo)}"
                                                class="admin-row-actions__danger"
                                            >
                                                <admin-icon name="trash"></admin-icon> {{ trans('todo.delete_todo') }}
                                            </b-dropdown-item-button>
                                        </table-row-action-dropdown>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="admin-table-pagination-wrap">
                        <pagination-record :page-length.sync="filterTodoForm.page_length" :records="todos" @updateRecords="getTodos"></pagination-record>
                    </div>
                </div>
                <div class="admin-list-table-card admin-empty-state linear-empty-state" v-if="!todos.total" role="status">
                    <div class="admin-empty-state__inner">
                        <div class="admin-empty-state__icon-wrap" aria-hidden="true">
                            <admin-icon name="check-circle"></admin-icon>
                        </div>
                        <h4 class="admin-empty-state__title">{{ trans('general.no_result_found') }}</h4>
                        <p class="admin-empty-state__text">{{trans('todo.todo')}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import todoForm from './form'
    import switches from 'vue-switches'
    import datepicker from 'vuejs-datepicker'
    import dateRangePicker from '../../components/date-range-picker'

    export default {
        components : { todoForm,switches,datepicker,dateRangePicker },
        data() {
            return {
                todos: {
                    total: 0,
                    data: []
                },
                filterTodoForm: {
                    keyword: '',
                    status: false,
                    start_date: '',
                    end_date: '',
                    sort_by : 'created_at',
                    order: 'desc',
                    page_length: helper.getConfig('page_length')
                },
                showFilterPanel: false,
                showCreatePanel: false
            };
        },
        mounted(){
            if(!helper.hasPermission('access-todo')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            if(!helper.featureAvailable('todo')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }

            this.getTodos();
        },
        methods: {
            hasPermission(permission){
                return helper.hasPermission(permission);
            },
            getTodos(page){
                if (typeof page !== 'number') {
                    page = 1;
                }
                let url = helper.getFilterURL(this.filterTodoForm);
                axios.get('/api/todo?page=' + page + url)
                    .then(response => response.data)
                    .then(response => this.todos = response)
                    .catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            editTodo(todo){
                this.$router.push('/todo/'+todo.id+'/edit');
            },
            confirmDelete(todo){
                return dialog => this.deleteTodo(todo);
            },
            deleteTodo(todo){
                axios.delete('/api/todo/'+todo.id)
                    .then(response => response.data)
                    .then(response => {
                        toastr.success(response.message);
                        this.getTodos();
                    }).catch(error => {
                        helper.showDataErrorMsg(error);
                    });
            },
            getStatus(todo){
                return todo.status ? ('<span class="admin-status-badge admin-status-badge--success">'+i18n.todo.complete+'</span>') : ('<span class="admin-status-badge admin-status-badge--danger">'+i18n.todo.incomplete+'</span>') ;
            },
            toggleStatus(todo){
                axios.post('/api/todo/'+todo.id+'/status')
                    .then(response => response.data)
                    .then(response => {
                        this.getTodos();
                        toastr.success(response.message);
                    })
                    .catch(error => {
                        helper.showDataErrorMsg();
                    });
            },
            sortList(field){
                if (this.filterTodoForm.sort_by === field) {
                    this.filterTodoForm.order = this.filterTodoForm.order === 'asc' ? 'desc' : 'asc';
                } else {
                    this.filterTodoForm.sort_by = field;
                    this.filterTodoForm.order = 'asc';
                }
            }
        },
        filters: {
          moment(date) {
            return helper.formatDate(date);
          }
        },
        watch: {
            filterTodoForm: {
                handler(val){
                    this.getTodos();
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
.linear-page-hero {
    align-items: center;
}

.linear-eyebrow,
.linear-section-head span {
    color: #635bff;
    font-size: 0.6875rem;
    font-weight: 800;
    letter-spacing: 0.08em;
    text-transform: uppercase;
}

.linear-command-actions {
    display: flex;
    justify-content: flex-end;
}

.linear-workqueue-grid {
    row-gap: 1rem;
}

.linear-admin-panel,
.linear-filter-card {
    padding: 1.1rem;
}

.linear-admin-panel--sticky {
    position: sticky;
    top: 5.5rem;
}

.linear-section-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1rem;
}

.linear-section-head h4 {
    margin: 0.25rem 0 0;
    color: #0f172a;
    font-size: 1rem;
    font-weight: 800;
    letter-spacing: -0.03em;
}

.linear-section-head--table {
    margin: 0;
    padding: 1rem 1.125rem;
    border-bottom: 1px solid #e2e8f0;
}

.linear-switch-row {
    display: flex;
    align-items: center;
    gap: 0.625rem;
    min-height: 2.25rem;
    color: #475569;
    font-weight: 600;
}

.linear-table-card {
    overflow: hidden;
    border-radius: 14px;
}

.linear-dense-table tbody td {
    vertical-align: middle;
}

.linear-table-primary {
    color: #0f172a;
    font-weight: 800;
}

.linear-table-muted {
    color: #64748b;
}

.linear-table-description {
    display: block;
    max-width: 22rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.linear-empty-state {
    border-radius: 14px;
}

@media (max-width: 991.98px) {
    .linear-admin-panel--sticky {
        position: static;
    }
}

@media (max-width: 575.98px) {
    .linear-page-hero {
        align-items: flex-start;
    }

    .linear-command-actions {
        justify-content: flex-start;
        width: 100%;
    }
}
</style>
